import React from 'react';
import { Brain } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1E2A4A] text-white/70 py-12 border-t border-white/10" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-118">
        <div className="flex justify-center mb-6" data-id="element-119">
          <div className="bg-white/10 p-3 rounded-2xl" data-id="element-120">
            <Brain size={32} className="text-[#E76F51]" data-id="element-121" />
          </div>
        </div>

        <h3 className="text-xl font-bold text-white mb-4" data-id="element-122">
          MEGAPACK TDAH EN CALMA™
        </h3>

        <p className="max-w-2xl mx-auto mb-8 text-sm leading-relaxed" data-id="element-123">
          El sistema más completo para familias con TDAH en Argentina. Porque
          acompañar a tu hijo no tiene que costarte la salud ni la paz.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8 font-medium" data-id="element-124">
          <a href="mailto:contacto@hacelohoy.shop" className="hover:text-white transition-colors" data-id="element-125">
            contacto@hacelohoy.shop
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-126">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-127">
            @hacelohoy.shop
          </a>
          <span className="hidden sm:inline text-white/30" data-id="element-128">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-129">
            hacelohoy.shop
          </a>
        </div>

        <p className="text-xs text-white/40" data-id="element-130">
          © hacelohoy.shop™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}